import FractaliaLogo from './logo';

export default FractaliaLogo;
